import appErrorService from '@/services/app/appErrorService';
import iccMarketService from '@/services/icc/iccMarketService';
import iccSsoService from '@/services/icc/iccSsoService';
import routerService from '@/services/route/routerService';
import {hideLoader, showLoader} from '@/state/slices/loadersSlice';
import {showBrowserNotCompatibleModalAction} from '@/state/slices/modalSlice';
import {dispatch} from '@/state/store';

const REDIRECT_LOADER_NAME = 'REDIRECT_LOADER_NAME';

const openExternalLink = async ({
    ssoTemplate,
    externalLink,
    externalLinkCode,
    openInBluefy,
    linkProcessor,
    ssoParams,
    link,
    deviceType,
    deviceSerialNumber,
}) => {
    let url = link;

    if (!url) {
        if (ssoTemplate) {
            dispatch(showLoader(REDIRECT_LOADER_NAME));

            url = await iccSsoService.resolveSsoUrlForOpen({
                ssoTemplate,
                ssoParams,
                linkProcessor,
                openInBluefy,
            });

            dispatch(hideLoader(REDIRECT_LOADER_NAME));

            if (!url) {
                appErrorService.showGlobalError();
                return;
            }
        }

        if (url && linkProcessor) {
            url = linkProcessor(url);
        } else {
            url = url || externalLink;
        }
    }

    if (!url && externalLinkCode) {
        dispatch(showLoader(REDIRECT_LOADER_NAME));

        url = (await iccMarketService.getExternalLink(externalLinkCode))?.value;

        dispatch(hideLoader(REDIRECT_LOADER_NAME));

        if (!url) {
            appErrorService.showGlobalError();
            return;
        }
    }

    if (openInBluefy) {
        showBrowserNotCompatibleModal({
            link: url,
            ssoTemplate,
            externalLink,
            openInBluefy,
            linkProcessor,
            ssoParams,
            deviceType,
            deviceSerialNumber,
        });
    } else {
        openLinkInNewTab(url);
    }

    return url;
};

const openLinkInNewTab = (url) => {
    if (url) routerService.blankLinkOpen(url);
};

/**
 * Opens a URL that is already fully resolved (e.g. SSO link from Redux). Shared by batch and single-token hooks.
 */
const openResolvedUrl = ({
    url,
    openInBluefy,
    ssoTemplate,
    externalLink,
    ssoParams,
    linkProcessor,
    deviceType,
    deviceSerialNumber,
}) => {
    if (!url) return;

    if (openInBluefy) {
        showBrowserNotCompatibleModal({
            link: url,
            ssoTemplate,
            externalLink,
            openInBluefy,
            linkProcessor,
            ssoParams,
            deviceType,
            deviceSerialNumber,
        });
    } else {
        openLinkInNewTab(url);
    }
};

const showBrowserNotCompatibleModal = (props) => {
    dispatch(showBrowserNotCompatibleModalAction(props));
};

export default {
    openExternalLink,
    openLinkInNewTab,
    openResolvedUrl,
};
